/*
 * @Author: wangbaihe
 * @Date: 2023-06-20 14:19:55
 * @LastEditors: wangbaihe
 * @LastEditTime: 2025-02-13 09:45:36
 * @FilePath: \common-mediax\src\apis\MediaCloudRemoteRepository\comandFeedback.js
 * @Description:
 */
import { createAPI } from '@common'
export default {
  //指令删除
  postDelete: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfnz0dpnnboe0efmfuf', 'POST', config),
  //提交指令反馈
  postFeedback: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfnz0dpnnboe0gffecbdl', 'POST', config),
  //获取指令反馈内容
  getFeedback: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfnz0dpnnboe0gffecbdl', 'GET', config),
  //获取首页最新的反馈列表
  getFeedbackLatest: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfnz0dpnnboe0mbuftu', 'GET', config, {
      isHideErrorMessage: true
    }),
  //获取指令详情
  getFeedbackDetail: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfnz0dpnnboe0efubjm', 'GET', config),
  //获取首页公告列表
  getnNticeListdata: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfnz0opujdf0mjtuebub', 'POST', config, {
      isHideErrorMessage: true
    }),
  //获取首页公告详情
  getnNticeDetail: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfnz0opujdf0efubjm', 'GET', config),
  //获取首页公告详情
  readNoticesAll: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfnz0opujdf0bmm0sfbe', 'GET', config)
}
